angular.module('unergie.main')
.controller('readingsCtrl', ($scope, $location, $state, MetaWatcher, DownloadService, DataAccess, DataAccessSearch, AuthService, BoFeaturesService,
    TableGeneratorService, XmlParser, AlertManager, ErrorCatcher) => {
    const MAX_SELECTIONS = 20
    $scope.measureTypes = [
        { id: 'conso', title: 'Consommation' },
        { id: 'EA', title: 'Énergie active' },
        { id: 'DD', title: 'Durée dépassement' },
        { id: 'DQ', title: 'Dépassement quadratique' },
        { id: 'ER', title: 'Énergie réactive' },
        { id: 'PA', title: 'Puissance atteinte' },
        { id: 'TF', title: 'Temps de fonctionnement' },
        { id: 'DP', title: 'Dépassement de puissance' },
        { id: 'EAAUTO', title: 'EA autoproduite' },
        { id: 'EAALLO', title: 'EA alloproduite' },
        { id: 'DE', title: 'Dépassement énergétique' },
    ]
    $scope.isPlum = AuthService.getAuth().organization === 'plum'
    $scope.adminMode = BoFeaturesService.getModuleFeatures('readings').adminMode
    $scope.expertMode = BoFeaturesService.getModuleFeatures('readings').expertMode

    $scope.readings = {
        refreshing: false,
        show: {},
        columns: {
            selector: $scope.adminMode ? { label: 'Selection', mode: 'filter_only' } : undefined,
            id: { label: 'ID', mode: $scope.adminMode ? 'search_operator' : 'hidden' },
            id_prm: { label: 'PRM', mode: 'search_wildcard' },
            id_contract: { label: 'ID contrat', mode: 'filter_only' },
            start_date: { label: 'Début', mode: 'search_date' },
            end_date: { label: 'Fin', mode: 'search_date' },
            motivation: { label: 'Motivation', mode: 'search_wildcard' },
            status: { label: 'Statut', mode: ($scope.adminMode || $scope.expertMode) ? 'search_wildcard' : 'hidden' },
            index_nature: { label: 'Nature', mode: 'search_wildcard' },
            last_index_nature: { label: 'Nature Préc.', mode: $scope.adminMode ? 'search_wildcard' : 'hidden' },
            origin: { label: 'Origine', mode: 'search_wildcard' },
            class: { label: 'Classe', mode: $scope.adminMode ? 'search_wildcard' : 'hidden' },
            temp_class: { label: 'Classe temp.', mode: 'search_wildcard' },
            face_digits: { label: 'Nb digits', mode: 'hidden' },
            serial: { label: 'Matricule', mode: ($scope.adminMode || $scope.expertMode) ? 'search_wildcard' : 'hidden' },
            value: { label: 'Valeur', mode: 'search_operator' },
            last_value: { label: 'Valeur Préc.', mode: ($scope.adminMode || $scope.expertMode) ? 'search_operator' : 'hidden' },
            internal_status: { label: 'Internal status', mode: 'hidden' },
            distributor_status: { label: 'Distributeur', mode: 'search_wildcard' },
            source: { label: 'Source', mode: 'hidden' },
            consumption: { label: 'Conso', mode: ($scope.adminMode || $scope.expertMode) ? 'search_operator' : 'hidden' },
            invoicing_status: { label: 'Facturation', mode: ($scope.adminMode || $scope.expertMode) ? 'search_wildcard' : 'hidden' },
            measure_type: { label: 'Type mesure', mode: $scope.adminMode ? 'search_strict' : 'hidden', hidden_search: 'search_strict' },
            comments: { label: 'Commentaires', mode: ($scope.adminMode || $scope.expertMode) ? 'search_wildcard' : 'hidden' },
        },
        instance: {
            page: () => 1,
            count: () => 25,
            sorting: () => ({}),
            filter: () => _.assign({ measure_type: ['conso', 'EA'] }, _.clone($location.search())),
        },
    }

    const getContractForReading = (reading) => {
        if (reading.contractsElec && reading.contractsElec.length) {
            if (reading.contractsElec.length === 1) {
                reading.id_contract = reading.contractsElec[0].id
                return
            }
            const readingEnd = moment(reading.end_date)
            _.each(reading.contractsElec, (c) => {
                const contractStart = moment(c.commissioning_date)
                if ((readingEnd.isAfter(contractStart) || (!reading.start_date && readingEnd.isSame(contractStart, 'day'))) &&
                    (!c.decommissioning_date || readingEnd.isBefore(moment(c.decommissioning_date)) || readingEnd.isSame(moment(c.decommissioning_date)))) {
                    reading.id_contract = c.id
                    return false
                }
            })
        }
    }

    const transformData = function (data) {
        let alternate = false

        return data.forEach((reading, i) => {
            const previous = data[i - 1]
            reading.start_date_SOD = reading.start_date && moment(reading.start_date).startOf('day').toISOString()
            reading.end_date_SOD = reading.end_date && moment(reading.end_date).startOf('day').toISOString()

            if (!previous || previous.id_prm !== reading.id_prm || previous.start_date_SOD !== reading.start_date_SOD || previous.end_date_SOD !== reading.end_date_SOD) {
                alternate = !alternate
            }

            reading.alternate = alternate
            getContractForReading(reading)
        })
    }

    $scope.checkStart = (reading) => {
        return !!_.find($scope.readings.instance.data, (r) => {
            return r.id !== reading.id && r.distributor_status === 'OK' && r.id_prm === reading.id_prm && r.temp_class === reading.temp_class && r.class === reading.class &&
                r.end_date === reading.start_date
        })
    }

    $scope.checkEnd = (reading) => {
        return !!_.find($scope.readings.instance.data, (r) => {
            return r.id !== reading.id && r.distributor_status === 'OK' && r.id_prm === reading.id_prm && r.temp_class === reading.temp_class && r.class === reading.class &&
                r.start_date === reading.end_date
        })
    }

    $scope.getSelected = () => {
        if (!$scope.readings.instance) {
            return []
        }
        return _.filter($scope.readings.instance.data, 'selected')
    }

    $scope.isSelectable = (reading) => (
        (reading.class !== 'S') && (!reading.invoicing_status || (reading.invoicing_status === 'CHECKED'))
    )

    $scope.canDuplicate = () => {
        return _.every($scope.readings.instance.data, (r) => !r.duplicating)
    }

    $scope.changeStatusPayload = {
        distributor_status: '',
    }

    $scope.changeStatusFields = {
        distributor_status: {
            label: 'Status',
            required: true,
            type: 'select',
            enum: [
                { label: 'ERROR', value: 'ERROR' },
                { label: 'CORRECTED', value: 'CORRECTED' },
                { label: 'OK', value: 'OK' },
                { label: 'REMOVED', value: 'REMOVED' },
                { label: 'IGNORED', value: 'IGNORED' },
            ],
        },
    }

    $scope.clonePayload = {}

    $scope.changeCommentPayload = {
        comments: '',
    }

    $scope.changeCommentFields = {
        comments: {
            label: 'Commentaires',
            type: 'text',
        },
    }

    $scope.correctionFields = {
        force: {
            label: 'Forcer',
            type: 'checkbox',
        },
        comments: {
            label: 'Commentaires',
            type: 'text',
        },
    }

    $scope.correctionPayload = {
        force: false,
        comments: '',
    }

    const reCalcCorrectionResult = () => {
        const readings = _.orderBy($scope.getSelected(), 'end_date', 'desc')
        $scope.errorMessages = []
        $scope.warningMessages = []
        $scope.correctionResult = null
        if (readings.length > 1) {
            if (_.some(readings, (r) => r.invoicing_status && !_.isNaN(Number(r.invoicing_status)))) {
                $scope.errorMessages.push(`Certaines relèves ont déjà donné lieu à une facture : ` +
                    `[${_.map(_.filter(readings, (r) => r.invoicing_status && !_.isNaN(Number(r.invoicing_status))), 'id').join(', ')}]`)
            }
            if (_.some(readings, (r) => r.id_prm !== readings[0].id_prm)) {
                $scope.errorMessages.push(`Tous ces readings ne concernent pas le même PRM : [${_.uniq(_.map(readings, 'id_prm')).join(', ')}]`)
            }
            if (_.some(readings, (r) => r.serial !== readings[0].serial)) {
                $scope.errorMessages.push(`Tous ces readings ne concernent pas le même compteur : [${_.uniq(_.map(readings, 'serial')).join(', ')}]`)
            }
            if (_.some(readings, (r) => r.temp_class !== readings[0].temp_class)) {
                $scope.errorMessages.push(`Tous ces readings ne concernent pas la même classe temporelle : [${_.uniq(_.map(readings, 'temp_class')).join(', ')}]`)
            }
            if (_.some(readings, (r) => r.class === 'S')) {
                $scope.errorMessages.push(`Impossible de corriger les auto-relèves du client`)
            }
            if (_.some(readings, (r) => r.class !== readings[0].class)) {
                $scope.errorMessages.push(`Tous ces readings ne proviennent pas de la même source : [${_.uniq(_.map(readings, 'class')).join(', ')}]`)
            }

            const end_date = moment(readings[0].start_date || readings[0].end_date)
            const value = readings[0].last_value || readings[0].value
            const index_nature = readings[0].start_date ? readings[0].last_index_nature : readings[0].index_nature
            let start_date = moment(readings[0].start_date)
            let last_value
            let last_index_nature
            let lastStartDate = moment(readings[0].start_date || readings[0].end_date)
            _.each(readings, (r) => {
                const rEndDate = moment(r.end_date)
                if (rEndDate.isBefore(lastStartDate) && !rEndDate.isSame(lastStartDate, 'day')) {
                    $scope.warningMessages.push(`Présence de trous dans les readings (${r.id}, ${rEndDate.toISOString()} => ${lastStartDate.toISOString()}), utiliser &force=true si c'est normal`)
                }
                lastStartDate = moment(r.start_date || r.end_date)
                start_date = moment(r.end_date)
                last_index_nature = r.index_nature
                last_value = r.value
            })

            $scope.correctionResult = {
                end_date,
                value,
                index_nature,
                last_index_nature,
                start_date,
                last_value,
            }
        }
    }

    $scope.toggleSelected = (reading) => {
        if (reading.class !== 'S') {
            // if selecting, verify not exceeding max selections authorized
            if (!reading.selected && ($scope.getSelected().length >= MAX_SELECTIONS)) {
                AlertManager.error(`Vous ne pouvez pas sélectionner plus de ${MAX_SELECTIONS} éléments`)
            } else {
                reading.selected = !reading.selected
            }
        }
        reCalcCorrectionResult()
    }

    $scope.refresh = () => {
        TableGeneratorService.getTable($scope.readings, 'readings', 'contractsElec,distributorStatusLabel', transformData, {
            orderBy: '-end_date,-start_date,id_prm,-class,origin,-temp_class',
            in: $scope.adminMode ? [] : [`class=F,S`],
        })
    }

    const dataRefreshed = () => {
        if ($scope.readings.instance) {
            _.each($scope.readings.instance.data, (r) => {
                r.selected = false
            })
        }
        reCalcCorrectionResult()
    }

    $scope.correction = () => {
        const payload = _.assign({ ids: _.map($scope.getSelected(), 'id') }, $scope.correctionPayload)
        $scope.correcting = true
        return DataAccess.correctReadings(payload).$promise.then((result) => {
            AlertManager.success('Correction OK')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.correcting = false
        })
    }

    $scope.revertCorrection = (reading) => {
        reading.cancelling = true
        return DataAccess.revertReadingCorrection({ id: reading.id }).$promise.then((result) => {
            AlertManager.success('Suppression OK')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            reading.cancelling = false
        })
    }

    $scope.modifyStatus = (reading) => {
        reading.modifying = true
        return DataAccess.updateReading({ id: reading.id }, $scope.changeStatusPayload).$promise.then((result) => {
            AlertManager.success('Modifié')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            reading.modifying = false
        })
    }

    $scope.modifySelectedStatus = () => {
        const updates = $scope.getSelected().map((reading) => {
            reading.modifying = true
            return {
                id: reading.id,
                distributor_status: $scope.changeStatusPayload.distributor_status,
            }
        })
        return DataAccess.updateReadingBatch({}, updates).$promise.then((result) => {
            AlertManager.addAlert({
                type: 'success',
                msg: `Modifications de statut en ${$scope.changeStatusPayload.distributor_status} ok`,
                detail: _.map(result, JSON.stringify),
                hideDetails: true,
            })
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.getSelected().forEach((reading) => (reading.modifying = false))
        })
    }

    $scope.modifyComment = (reading) => {
        reading.modifying = true
        return DataAccess.updateReading({ id: reading.id }, $scope.changeCommentPayload).$promise.then((result) => {
            AlertManager.success('Modifié')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            reading.modifying = false
        })
    }

    $scope.prepareClone = (reading) => {
        _.assign($scope.clonePayload, reading)
        delete $scope.clonePayload.consumption
    }

    $scope.clone = (reading, mode) => {
        const payload = _.pick($scope.clonePayload, [
            'id_prm',
            'start_date',
            'end_date',
            'status',
            'index_nature',
            'last_index_nature',
            'origin',
            'class',
            'measure_type',
            'temp_class',
            'serial',
            'value',
            'last_value',
            'consumption',
            'invoicing_status',
            'comments',
        ])
        if (payload.last_value === null) {
            delete payload.last_value
        }
        if (payload.consumption === null) {
            delete payload.consumption
        }
        if (payload.start_date) {
            payload.start_date = moment(payload.start_date).toISOString()
        } else {
            delete payload.start_date
        }
        payload.end_date = moment(payload.end_date).toISOString()
        // reset tcfe taxes so they can be calculated later by the batch
        payload.tccfe_value = null
        payload.tdcfe_value = null
        payload.tccfe_amount = null
        payload.tdcfe_amount = null
        payload.tcfe_status = null
        reading[`${mode}ing`] = true
        return DataAccess.cloneReading({ id: reading.id, mode }, payload).$promise.then((result) => {
            AlertManager.success('Modifié')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            reading[`${mode}ing`] = false
        })
    }

    $scope.canDl = (reading) => {
        return reading.source && reading.source.startsWith('s3://')
    }

    $scope.dl = (reading) => {
        if (reading.source && reading.source.startsWith('s3://')) {
            DownloadService.s3Download(reading.source)
        }
    }

    $scope.isActive = (state) => $state.is(state)

    const activate = () => {
        $scope.refresh()
        MetaWatcher.watch('TABLE_READINGS_DATA_CHANGED', 'readings', $scope, dataRefreshed)
    }

    $scope.prepareDuplicate = (reading) => {
        if (!$scope.canDuplicate()) {
            return
        }
        reading.duplicating = true
        _.assign($scope.clonePayload, reading)
        $scope.clonePayload.start_date = $scope.clonePayload.start_date && moment($scope.clonePayload.start_date).toDate()
        $scope.clonePayload.end_date = $scope.clonePayload.end_date && moment($scope.clonePayload.end_date).toDate()
        delete $scope.clonePayload.consumption
    }

    activate()
})
